export default "__VITE_ASSET__168964e1__"